<template>
  <section class="block portal client-portal login">
    <div class="portal__wrapper">
      <div class="version">version: {{ getVersion }}</div>
      <form class="portal__content form" autocomplete="on" @submit.prevent="login">
        <h1 class="portal__title title--xl">{{ getUiString(['login', 'title']) }}</h1>
        <div class="form__row"
          @click="setInputs"
          @input="error = false">
          <lennoc-input
            id="userEmail"
            type="email"
            :validators="emailValidators"
            :label="getUiString(['login', 'email'])"
            v-model="email"
            :domClass="[getErrorClass]"
            ref="email"
          ></lennoc-input>
          <lennoc-input
            id="userPw"
            type="password"
            :label="getUiString(['login', 'password'])"
            v-model="pw"
            :domClass="[getErrorClass]"
            ref="pw"
          ></lennoc-input>
          <div class="form__group--error">
            <div class="error" v-if="error">{{ getErrorMessage }}</div>
          </div>
        </div>
        <div class="group">
          <button class="button button--prim" :disabled="isDisabled" value="Inloggen">{{ getUiString(['login', 'button']) }}</button>
          <a class="link link--login" href="#" @click.prevent="newpassword">{{ getUiString(['login', 'password_forgotten']) }}</a>
        </div>
        <div class="group" v-if="getlanguage">
          <h4 class="portal__title title--xs" > <lennoc-icon image="exclamation" class="exclamation-icon icon--circled "></lennoc-icon>{{ getInfoString }} </h4>
        </div>
      </form>
    </div>
    <lennoc-spinner v-if="busy" />
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import { email } from '@/validators/index'

const NO_ERROR = 0
const ACCESS_DENIED = 1
const NETWORK_ERROR = 2
const UNKNOWN_ERROR = 3

export default {
  name: 'LoginView',
  mounted () {
    this.setInputs()
    if (this.$route.name === 'logout') {
      this.busy = true
      this.$store.dispatch('logout').finally(() => {
        const redirect = window.location.origin
        window.location.replace(redirect)
      })
    } else if (this.$store.state.loggedIn) {
      this.$router.push('/home')
    } else if (this.$route.name === 'internallogin') {
      const credentials = {
        contactId: this.$route.params.contactid,
        internalUser: this.$route.params.internaluser
      }
      this.busy = true
      this.$store.dispatch('internalLogin', credentials)
        .then(
          () => this.$router.push('/home'),
          err => {
            if (err.message.indexOf('Network Error') > -1) {
              this.error = NETWORK_ERROR
            } else if (err.message.indexOf('403') > -1) {
              this.error = ACCESS_DENIED
            } else {
              this.error = UNKNOWN_ERROR
            }
          })
        .catch(() => { this.error = UNKNOWN_ERROR })
        .finally(() => { this.busy = false })
    }
  },
  methods: {
    async login () {
      this.busy = true
      this.error = NO_ERROR
      const { email, pw } = this
      try {
        const result = await this.$store.dispatch('login', { email, pw })
        if (result.status === 403) {
          this.error = ACCESS_DENIED
        } else {
          try {
            const redirect = this.getRedirect
            if (redirect) {
              this.$store.dispatch('setPostLoginRedirect', null)
              window.location.replace(redirect)
            } else {
              this.$router.push('/reaffirm')
            }
          } catch (error) {
            this.error = UNKNOWN_ERROR
          }
        }
      } catch (error) {
        this.error = NETWORK_ERROR
      }
      this.busy = false
    },
    newpassword () {
      this.$router.push('/forgot')
    },
    setInputs () {
      for (const ref in this.$refs) {
        setTimeout(() => {
          if (this.$refs[ref] && this.$refs[ref].$el.children[0].children[0]) {
            const styles = window.getComputedStyle(this.$refs[ref].$el.children[0].children[0])
            if (styles.animationName === 'onAutoFillStart') {
              this.autofill = true
              this.$refs[ref].hasFocus = true
            }
          }
        }, 600)
      }
    }
  },
  data () {
    return {
      autofill: false,
      busy: false,
      error: NO_ERROR,
      email: '',
      pw: ''
    }
  },
  computed: {
    ...mapGetters({
      getUiString: 'uistrings/getUiString',
      getRedirect: 'getPostLoginRedirect',
      getVersion: 'getVersion'
    }),
    emailValidators () {
      const vld = email
      email.message = this.getUiString(['login', 'invalid_email'])
      return [vld]
    },
    isDisabled () {
      if (this.autofill) {
        return false
      }
      return this.busy || this.email === '' || this.pw === ''
    },
    getErrorClass () {
      return this.error > 0 ? 'form__group--error' : ''
    },
    getlanguage () {
      const validLanguages = ['fr', 'es', 'tr']
      const url = new URL(window.location.href)
      const pathSegments = url.pathname.split('/').filter(segment => segment !== '')
      return validLanguages.includes(pathSegments[0]) ? pathSegments[0] : null
    },
    getInfoString () {
      return this.getUiString(['login', 'info_text', this.getlanguage])
    },
    getErrorMessage () {
      switch (this.error) {
        case ACCESS_DENIED:
          return this.getUiString(['login', 'login_fail'])
        case NETWORK_ERROR:
          return this.getUiString(['login', 'connection_error'])
        case UNKNOWN_ERROR:
          return this.getUiString(['login', 'unknown_error'])
        default:
          return ''
      }
    }
  }
}
</script>
